import Image from 'next/legacy/image';

export default function TypedreamPaste() {
  return (
    <li>
      <h3 id="paste-typedream">Paste it in your Typedream site</h3>
      <p>
        Type <code>/</code> and look for <code>Embed</code>. In the <code>Link</code> section, paste
        the copied link.
      </p>
      <p>
        Click on <code>Embed link & iframe</code> button.
      </p>
      <Image src="/guides/typedream-paste.jpg" width={1584} height={818} alt="typdream editor" />
      <p>Adjust the block width and height by dragging the handles as needed.</p>
    </li>
  );
}
